import React, { useState } from "react";
import assam from "../assets/assam.jfif";
import london from "../assets/london.jfif";
import jaipur from "../assets/jaipur.jpg";
import mumbai from "../assets/mumbai.jpg";
import Memory from "./Memory";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CREATE_MEMORIES = () => {
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [image, setImage] = useState(null);
  const [description, setDescription] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [data, setData] = useState([
    {
      id: 1,
      imgSrc: assam,
      title: "Assam Visit",
      date: "19/Sep/2021",
      description:
        "Assam is a state in northeastern India, south of the eastern Himalayas along the Brahmaputra and Barak River valleys.",
    },
    {
      id: 2,
      imgSrc: jaipur,
      title: "Jsipur Visit",
      date: "21/Sep/2021",
      description:
        "Jaipur , formerly Jeypore, is the capital and largest city of the Indian state of Rajasthan.",
    },
  ]);

  const onImageChange = (e) => {
    if (e.target.files) {
      setImage(URL.createObjectURL(e.target.files[0]));
    }
  };

  const addMemory = (e) => {
    e.preventDefault();
    let dataCopy = [...data];
    dataCopy.push({
      id: data.length + 1,
      imgSrc: image,
      title: title,
      date: date,
      description: description,
    });
    setData(dataCopy);
    (function () {
      toast.success("Success Notification !", {
        position: toast.POSITION.TOP_CENTER,
      });
    })();
    setTitle("");
    setDate("");
    setImage(null);
    setDescription("");
  };

  const editMemory = (id) => {
    setIsEdit(true);
    let memory_copy = data[id - 1];
    setTitle(memory_copy.title);
    setDescription(memory_copy.description);
  };

  const updateMemory = (e) => {
    e.preventDefault();
    let dataCopy = [...data];
    dataCopy.push({
      id: data.length + 1,
      imgSrc: image,
      title: title,
      date: date,
      description: description,
    });
    setData(dataCopy);
    setTitle("");
    setDate("");
    setImage(null);
    setDescription("");
    setIsEdit(false);
  };
  return (
    <div>
      <h1>My Memories</h1>
      <div
        id="carouselExampleFade"
        class="carousel slide carousel-fade"
        data-bs-ride="carousel"
        style={{
          marginTop: "100px",
        }}
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <div class="card" style={{ width: "18rem" }}>
                <img src={london} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">Visit to London</h5>
                  <br />
                  <p>15/Sep/2022</p>
                  <br />
                  <br />
                  <p class="card-text">
                    London, city, capital of the United Kingdom. It is among the
                    oldest of the world’s great cities
                  </p>
                </div>
              </div>
              <div class="card" style={{ width: "18rem" }}>
                <img src={mumbai} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">Visit to Mumbai</h5>
                  <br />
                  <p>17/Sep/2022</p>
                  <br />
                  <br />
                  <p class="card-text">
                    Mumbai is the capital city of the Indian state of
                    Maharashtra and the de facto financial centre of India.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {data.map((memory) => {
            return (
              <div class="carousel-item" key={memory.id}>
                <div
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <Memory
                    url={memory.imgSrc}
                    title={memory.title}
                    date={memory.date}
                    description={memory.description}
                    id={memory.id}
                    click={editMemory}
                  />
                </div>
              </div>
            );
          })}
        </div>
        <ToastContainer />
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleFade"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleFade"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

      {isEdit ? (
        <>
          <h1>Edit Your Memory</h1>
          <div className="container">
            <div>
              <form className="form-group">
                <input
                  class="form-control"
                  type="file"
                  onChange={onImageChange}
                  id="formFile"
                />
                <br />
                <input class="form-control" type="date" />
                <br />
                <input
                  type="text"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Edit Your Title Here ✍️"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                <br />
                <input
                  type="text"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Edit Description ✍️"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                <br />
                <button
                  className="btn btn-outline-success"
                  onClick={updateMemory}
                >
                  Update
                </button>
              </form>
            </div>
          </div>
        </>
      ) : (
        <>
          <h1>Add Your Memory</h1>
          <div className="container">
            <div>
              <form className="form-group">
                <input
                  class="form-control"
                  type="file"
                  onChange={onImageChange}
                  id="formFile"
                />
                <br />
                <input class="form-control" type="date" />
                <br />
                <input
                  type="text"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Title Goes Here ✍️"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                <br />
                <input
                  type="text"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Please Add Description ✍️"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                <br />
                <button className="btn btn-outline-success" onClick={addMemory}>
                  Add
                </button>
              </form>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CREATE_MEMORIES;
